import { api } from './client.js';

export const authApi = {
  me: () => api.get('/me'),
  login: ({ email, password, mfaCode, passkeyResponse }) =>
    api.post('/auth/login', { email, password, mfaCode, passkeyResponse }),
  passkeyLoginStart: () => api.post('/auth/login/passkey/start'),
  passkeyLoginFinish: ({ challengeId, response }) =>
    api.post('/auth/login/passkey/finish', { challengeId, response }),
  logout: () => api.post('/auth/logout'),
  refresh: () => api.post('/auth/refresh'),
  updateProfile: (body) => api.patch('/me', body),
  changePassword: (body) => api.post('/me/password', body),
  selectStore: (storeId) => api.post('/me/active-store', { storeId })
};
